var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClickToCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4996 9.98431V11.7908C13.5003 11.9585 13.4659 12.1245 13.3986 12.2781C13.3313 12.4318 13.2325 12.5697 13.1087 12.6831C12.9849 12.7965 12.8387 12.8828 12.6795 12.9365C12.5203 12.9903 12.3517 13.0102 12.1843 12.9951C10.3277 12.7938 8.54426 12.1606 6.97734 11.1465C5.51953 10.222 4.28356 8.98843 3.3572 7.53351C2.33752 5.96259 1.70294 4.17405 1.5049 2.31277C1.48982 2.14625 1.50965 1.97843 1.56312 1.81998C1.61659 1.66153 1.70254 1.51592 1.81548 1.39244C1.92843 1.26896 2.0659 1.1703 2.21915 1.10274C2.37239 1.03519 2.53805 1.00022 2.70558 1.00006H4.51565C4.80846 0.997182 5.09233 1.10067 5.31435 1.29122C5.53636 1.48178 5.68138 1.74641 5.72236 2.03578C5.79876 2.61389 5.94044 3.18152 6.14471 3.72785C6.22589 3.94338 6.24346 4.17761 6.19534 4.4028C6.14721 4.62799 6.03542 4.83469 5.8732 4.99841L5.10694 5.76315C5.96585 7.27069 7.21655 8.51891 8.72708 9.37612L9.49334 8.61138C9.65739 8.44948 9.8645 8.33791 10.0901 8.28988C10.3158 8.24185 10.5505 8.25939 10.7664 8.3404C11.3138 8.54427 11.8826 8.68567 12.4619 8.76192C12.7549 8.80318 13.0226 8.95052 13.214 9.1759C13.4053 9.40128 13.507 9.68899 13.4996 9.98431Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClickToCall);
export default __webpack_public_path__ + "static/media/icon-click-to-call.9baf910a56cf31ca5bbc4e6bf88cb759.svg";
export { ForwardRef as ReactComponent };